import Avatar from './Avatar'
import './Avatar.sass'
export { default as EditAvatar } from './EditAvatar'
export default Avatar
